(() => {
  'use strict';
  if (window.BSEasySellStyleInitialized) return;
  window.BSEasySellStyleInitialized = true;
  const targets = [
    '.es-popup-button',
    '.es-popup-button .es-button-title',
    '.es-css .es-form-container',
    '.es-css .es-form-header [style]',
    '.es-css .es-cta-btn',
    '.es-css .es-checkout-btn',
    '.es-css .es-cta-btn .es-button-content span',
    '.es-css .es-checkout-btn .es-button-content span'
  ].join(',');
  // The app writes inline !important paint styles. Release only these visual
  // properties to the theme stylesheet. Never change visibility, disabled,
  // loading, layout dimensions, field values, events, or payment behavior.
  const paint = [
    'color', 'background', 'background-color', 'background-image',
    'font-size', 'font-style', 'font-weight',
    'border-color', 'border-style', 'border-width', 'border-radius', 'box-shadow'
  ];
  function normalize(element) {
    for (const property of paint) {
      if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
    }
  }
  function visit(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(targets)) normalize(node);
    node.querySelectorAll(targets).forEach(normalize);
  }
  visit(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches(targets)) normalize(record.target);
      } else {
        record.addedNodes.forEach(visit);
      }
    }
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
})();
